export default {
  DEFAULT: 'default',
  ROUND: 'round',
} as const;
